var borders_default = {
  "borderT": "GZfw7",
  "borderB": "kUouf",
  "borderL": "_4sATx",
  "borderR": "OuVO2",
  "borderColorOverride": "TKqBO"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
